export default function Title({ children }) {
  return (
    <div className='text-xl md:text-lg text-gray-900 font-bold tracking-[0.2em] h-8'>
      { children }
    </div>
  )
}
